'use strict'

import ImageResizeService from '../services/ImageResizeService.coffee'
import { $q, $log } from '../helpers/angular-migration-helpers'

runningFirefox = navigator.userAgent.indexOf('Firefox') > 0

supportedFileTypes = /^image\/(gif|jpeg|png|svg\+xml)$/
thumbnailSize = 200
maxResizes = 3
thumbnailQuality = 90
thumbnailType = 'image/jpeg'

# The Thumbnails is the class that processes the actual blob and
# transforms it into a small thumbnail.
class Thumbnails
  generatePreview = (thumbFileInfo) ->
    dfd = $q.defer()

    # Obtain the original file information
    originalFile = thumbFileInfo.originalFile

    # Filename required for debugging
    if runningFirefox
      fileName = "#{originalFile.name}[#{
        originalFile.size
      } bytes #{thumbnailSize}x#{thumbnailSize}]"

    promise = ImageResizeService.resizeImage originalFile.blob,
      maxWidth: thumbnailSize
      maxHeight: thumbnailSize
      cover: true
      maxResizes: maxResizes

    success = (context) ->
      #if runningFirefox
      #  $log.debug "#{fileName}: Image resize callback called. Converting to blob..."

      # Convert the canvas to a BLOB
      context.canvas.toBlob(
        (blob) ->
          #if runningFirefox
          #  $log.debug "#{fileName}: Image resize completed. Resized blob is #{blob.size} bytes."

          # Use the original blob's name
          blob.name = thumbFileInfo.name

          # Save the scaled image
          thumbFileInfo.blob = blob
          thumbFileInfo.size = blob.size

          # Save the preview blob
          originalFile.getPreviewBlob = -> blob

          # Reset the previous URL preview (if any)
          delete originalFile.urlPreview

          # Transformation completed
          dfd.resolve blob
      ,
        thumbnailType
        thumbnailQuality
      )

    fail = (errorMsg) ->
      # Log warning
      $log.warn(
        "#{thumbFileInfo.getCompletePath()}: Image resize error: #{errorMsg}"
      )

      # Reset blob
      thumbFileInfo.blob = new Blob []
      thumbFileInfo.size = 0

      # Save the preview blob
      originalFile.getPreviewBlob = -> null

      # Reset the previous URL preview (if any)
      delete originalFile.urlPreview

      # Transformation completed
      dfd.resolve()

    promise.then success, fail
    dfd.promise

  constructor: (transfer) ->
    @transfer = transfer

  getString: ->
    'thumbnails'

  preProcessFile: (imageFileInfo) ->
    # Check if it is a supported file
    if supportedFileTypes.test imageFileInfo.type
      # Add a thumbnail for this file
      @transfer.insertBlob(
        imageFileInfo.blob
        0
        [
          preProcessFile: (thumbFileInfo) =>
            # Link the thumbnail to the original file
            imageFileInfo.addLinkedFile thumbFileInfo, '0' # Linked file 0 means a thumbnail

            # All thumbnails are required for a confirmation, because
            # the thumbnails are used in emails, but also in the detail pages
            thumbFileInfo.requiredForConfirmation = true

            # Alter the thumbnail file information
            thumbFileInfo.size = 20 * 1000
            thumbFileInfo.blob = null
            thumbFileInfo.processActions = [this]

            # Only upload thumbnails when no encryption is used
            thumbFileInfo.requiresUpload = =>
              !@transfer.status.isEncrypted

            # Obtain the preview
            imageFileInfo.getPreviewBlob = ->
              # Prevent that this method is invoked multiple times
              imageFileInfo.getPreviewBlob = null

              # Generate the preview
              generatePreview thumbFileInfo
        ]
        true
        null
        imageFileInfo.id
      )

    # Continue processing
    return true

  processFileBlocks: (fileInfo) ->
    # It only blocks if no thumbnail has been generated yet
    !fileInfo.blob

  processFile: (fileInfo) ->
    generatePreview fileInfo if !fileInfo.blob

export default Thumbnails
